import React from "react";
import "./landpage.scss";
import Header from "../header/header";
import Carousel from "../../components/carousel/carousel";
import Footer from "../../components/footer/footer";
import { Link } from "react-router-dom";
import { motion } from "framer-motion"

function Landpage() {
  return (
    <>
      <section className="first">
        <Header />
      </section>
      <motion.section 
        id="second"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.3 }}
        className="second">
        <h3>Home Care Specialists</h3>
        <h4>Understanding our clients’ needs</h4>
        <div className="second__para">
          <p>
            Daily Help United Limited provides healthcare staffing to individuals, families, 
            and healthcare organizations. We supply qualified professionals to home health 
            agencies, hospice services, care homes, hospitals, nursing homes, and assisted 
            living facilities. Our focus is simple: match skilled healthcare workers with clients 
            who need them while handling recruitment, credentialing, and placement.
          </p>
          <p>
            We provide fully trained care staff through a rigorous selection process, 
            placing only individuals with strong moral standards and professional abilities. 
            We work directly with healthcare facilities to understand their staffing needs 
            and provide families with vetted professionals for home care. Our team manages 
            administrative details so you can focus on quality patient care and family wellbeing.
          </p>
        </div>
      </motion.section>
      <motion.section 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.4 }}
        className="third">
        <div className="container">
          <h3 className="section-title">Why Daily United Help?</h3>
          <h1 className="main-heading">It’s good to live the life you want</h1>
          <p className="intro">
            Whether it’s your mum or dad, aunt or uncle, a neighbour who’s always cared for you or
            a partner who’s stood by you, we’re here so those who mean the most to you can live
            the life they want.
          </p>

          <Link to="/about" className="btn-outline">Why choose us?</Link>

          <div className="info-grid">
            <div className="info-block">
              <h4>Extensive experience</h4>
              <p>
                Since 2004, we’ve helped people live life on their terms, in their homes.
                With 20+ years of learning from people like you, looking after your loved ones
                and constantly refining our Home Care service.
              </p>
            </div>

            <div className="info-block">
              <h4>Quality you can count on</h4>
              <p>
                Every day, we aim to provide the best Home Care. We train our Care Experts, track
                your loved one’s health, and keep you involved every step, ensuring our quality of
                care puts your mind at ease.
              </p>
            </div>

            <div className="info-block">
              <h4>National yet local</h4>
              <p>
                Daily United Help offers the best of both worlds: UK-wide for top training and
                seamless cover, locally-owned to get to know you and match your loved one with
                the right Care Expert for their needs.
              </p>
            </div>

            <div className="info-block">
              <h4>End-to-end care</h4>
              <p>
                Whether it’s companionship for a few hours a week or complex 24/7 care, we meet
                all your Home Care needs. So if your loved one’s situation changes, they won’t
                have to change care providers too.
              </p>
            </div>
          </div>
        </div>
      </motion.section>

      <section className="fourth">
        <h1>Daily Help United Care Services</h1>
        <h2>Care, Support & Nursing at Home</h2>
        <Carousel />
      </section>

      <section className="fifth">
        <h1>Get in touch today to <br />see how we can help</h1>
        <Link to='/contact' className="btn-primary">Get in Touch</Link>
      </section>
      <Footer />
    </>
  );
}

export default Landpage;
